import React from "react";

/*eslint-disable */

declare const window: any;
const GoAstaraComponent: React.FC = () => {
  return (
    <div className="go-astara">
      <div className="row">
        <div className="col-md-6 col-sm-12 mb-4 d-flex justify-content-center align-items-center">
          {/* H2 - Título de la sección */}
          <h2 className="title">¿Quieres más información?</h2>
        </div>
        <div className="col-md-6 col-sm-12 mb-4 d-flex justify-content-center align-items-center">
          <a href="https://astara.com/es/home" className="btn-go-astara">Ir a Astara</a>
        </div>
      </div>
    </div>
  );
};

export default GoAstaraComponent;